export default "__VITE_ASSET__b58cb20c__"